/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/theater/details/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'theater/details/desktop.app', exports: {} };
const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import overlayAuto from '@take-2/fd-modules/shared/misc/overlayAuto';



import closestTheaters from '@take-2/fd-modules/theater/details/desktop/closestTheaters';



import exhibitorPoints from '@take-2/fd-modules/theater/details/shared/exhibitorPoints';



import hearts from '@take-2/fd-modules/shared/utils/hearts';



import loadCalendar from '@take-2/fd-modules/theater/details/shared/tdp.loadCalendar';



import rottenTomatoesRating from '@take-2/fd-modules/shared/utils/rottenTomatoesRating';



import showModals from '@take-2/fd-modules/theater/details/shared/tdp.showModals';



import theaterAmenities from '@take-2/fd-modules/theater/shared/theaterAmenities';



import theaterTicketingOptions from '@take-2/fd-modules/theater/shared/theaterTicketingOptions';



import theaterConcessionAmenity from '@take-2/fd-modules/theater/shared/theaterConcessionAmenity';

function run() {
    checkDependencies(module.name, debugLog);
    showModals.init();
    if (document.querySelector('.js-domain-redirect-modal')) {
        return;
    }
    closestTheaters.init();
    theaterTicketingOptions.init();
    theaterAmenities.init();
    theaterConcessionAmenity.init();
    overlayAuto.init();
    hearts.init();
    rottenTomatoesRating.attach();
    loadCalendar.init();
    exhibitorPoints.init();
}
run();
export default {  };